// removed by extract-text-webpack-plugin
module.exports = {"NormalFaq":"NormalFaq__vrIIQ","MobileFaq":"MobileFaq__27iad"};


//////////////////
// WEBPACK FOOTER
// ./components/Buttons/FaqButton/style.scss
// module id = H7oh
// module chunks = 0